import { defineComponent, ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';
import { vClickOutside } from '../../directives/click-outside/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiModal",
  props: {
    value: { type: Boolean, required: false, default: false },
    closeOnClickOutside: { type: Boolean, required: false, default: true }
  },
  emits: ["input"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const OPEN_STATE_CLASS = "fds-ui-modal--open";
    const root = ref();
    const modalContainer = ref();
    const onClickOutside = () => {
      if (props.closeOnClickOutside && props.value) {
        close();
      }
    };
    const close = () => {
      emits("input", false);
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        close();
        return;
      }
      if (!modalContainer.value) {
        return;
      }
      const focusableList = modalContainer.value.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableList.length < 2 && event.key === "Tab") {
        event.preventDefault();
        return;
      }
      const last = focusableList.length - 1;
      if (event.key === "Tab" && !event.shiftKey && event.target === focusableList[last]) {
        event.preventDefault();
        focusableList[0].focus();
      } else if (event.key === "Tab" && event.shiftKey && event.target === focusableList[0]) {
        event.preventDefault();
        focusableList[last].focus();
      }
    };
    const focusOnFirstElement = () => {
      if (!modalContainer.value) {
        return;
      }
      const focusableInputElements = modalContainer.value.querySelectorAll("input, select, textarea");
      if (focusableInputElements.length > 0) {
        focusableInputElements[0].focus();
        return;
      }
      const focusableList = modalContainer.value.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableList.length > 0) {
        focusableList[0].focus();
      }
    };
    const onVisibilityChange = async () => {
      if (props.value) {
        await nextTick().then(() => {
          focusOnFirstElement();
        });
        document.body.classList.add(OPEN_STATE_CLASS);
      } else {
        document.body.classList.remove(OPEN_STATE_CLASS);
      }
    };
    onMounted(() => {
      registerEscapeListener();
      if (!root.value) {
        return;
      }
      document.body.append(root.value);
    });
    onBeforeUnmount(() => {
      var _a;
      document.body.classList.remove(OPEN_STATE_CLASS);
      removeEscapeListener();
      (_a = root.value) == null ? void 0 : _a.remove();
    });
    watch(
      () => props.value,
      () => {
        void onVisibilityChange();
      },
      { immediate: true }
    );
    const registerEscapeListener = () => {
      document.addEventListener("keyup", keyUpEventListener);
    };
    const removeEscapeListener = () => {
      document.removeEventListener("keyup", keyUpEventListener);
    };
    const keyUpEventListener = (event) => {
      if (event.key === "Escape") {
        close();
      }
    };
    return { __sfc: true, OPEN_STATE_CLASS, props, emits, root, modalContainer, onClickOutside, close, onKeyDown, focusOnFirstElement, onVisibilityChange, registerEscapeListener, removeEscapeListener, keyUpEventListener, vClickOutside };
  }
});

export { _sfc_main as default };
